import apiFeedback from '@/api/feedback'
import {isEmpty, isNil, pipe, propOr, reject, unless} from 'ramda'

const state = {
  data: [],
  isLoading: false,
  error: null,
  total: null,
  lastPage: null,
}

export const mutationTypes = {
  getFeedbackStart: '[feedback] Get feedback start',
  getFeedbackSuccess: '[feedback] Get feedback success',
  getFeedbackFailure: '[feedback] Get feedback failure',
}

export const actionTypes = {
  getFeedback: '[feedback] Get trainer',
}

const mutations = {
  [mutationTypes.getFeedbackStart](state) {
    state.isLoading = true
    state.error = null
    state.data = []
  },

  [mutationTypes.getFeedbackSuccess](state, payload) {
    if (payload.isAdd) {
      state.data = [...state.data, ...payload.list]
    } else {
      state.data = payload.list
    }

    state.total = payload.total
    state.lastPage = payload.lastPage
    state.isLoading = false
  },

  [mutationTypes.getFeedbackFailure](state, payload) {
    state.isLoading = false
    state.error = payload
  },
}

const actions = {
  [actionTypes.getFeedback](context, data) {
    const params = pipe(
      propOr(null, 'params'),
      unless(isNil, reject(isEmpty))
    )(data)

    const isAdd = propOr(false, 'isAdd', data)
    context.commit(mutationTypes.getFeedbackStart)
    return new Promise((resolve) => {
      apiFeedback
        .getFeedbackList(params)
        .then((response) => {
          context.commit(mutationTypes.getFeedbackSuccess, {
            ...response.data,
            isAdd,
          })
          resolve(response.data)
        })
        .catch((error) => {
          context.commit(mutationTypes.getFeedbackFailure, error)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
